module.exports = __webpack_public_path__ + "static/media/spin-wheel-btn.aeb00e2d.svg";